module.exports = __webpack_public_path__ + "static/media/simplification.d9761be8.gif";